import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { StepViewModel } from '@app/shared/model/stepViewModel';
import { finalize, take } from 'rxjs';
import { StepSidebarComponent } from '../step-sidebar/step-sidebar.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-step-wrapper',
  templateUrl: './step-wrapper.component.html',
  styleUrls: ['./step-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [StepSidebarComponent, MatProgressSpinner, AsyncPipe],
})
export class StepWrapperComponent implements OnInit, OnDestroy {
  @Input() public model: StepViewModel<string, object>;
  @ViewChild('cancelModal', { static: true }) public cancelModal: ModalComponent;

  public isLoading$ = new BehaviorSubject<boolean>(false);

  private subscriptions = new Subscription();

  public ngOnInit(): void {
    this.subscriptions.add(
      this.model.cancel.subscribe(() => {
        this.cancelModal.open();
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public openCancelModal(): void {
    this.cancelModal.open();
  }

  public handleNextStep(): void {
    if (this.model.currentStepIdx === this.model.steps.length - 1) {
      this.handleSubmit();
    } else {
      this.handleSaveAndContinue();
    }
  }

  public handleSubmit(): void {
    this.isLoading$.next(true);

    const subscription = this.model.done
      .pipe(
        take(1),
        finalize(() => this.isLoading$.next(false))
      )
      .subscribe();

    this.subscriptions.add(subscription);
    this.model.next().catch(() => {
      this.isLoading$.next(false);
    });
  }

  public handleSaveAndContinue(): void {
    this.isLoading$.next(true);
    const subscription = this.model.saveAndContinue();

    subscription.add(() => {
      this.isLoading$.next(false);
    });

    this.subscriptions.add(subscription);
  }
}
